<div class="my-3 my-md-5">
  <div class="container-fluid">
      <h1 class="page-title">Cab Details</h1>
  </div>

  <div class="container-fluid px-4 pt-4 card">
      <mat-accordion class="example-headers-align" multi>
              <mat-expansion-panel>
                <mat-expansion-panel-header>
                  <mat-panel-title>
                      <i class="fas fa-sliders-h"></i> <span class="pl-2">Filters</span>
                  </mat-panel-title>
                </mat-expansion-panel-header>
                  <div class="row mb-2 mt-2">
                      <div class="col-sm-3 mt-2"><input class="form-control" [(ngModel)]="search" type="text" (keyup)="loadCabDetails(0,perpage)" placeholder="Search" /></div>
                      <div class="col-sm-2 mt-2">
                          <mat-select  placeholder="Cab Status" (selectionChange)="loadCabDetails(0,perpage)" [(ngModel)]="cab_status">
                              <mat-option >All</mat-option>
                              <mat-option value="0">Pending</mat-option>
                              <mat-option value="1">Booked</mat-option>
                              <mat-option value="2">Cancelled</mat-option>
                              <mat-option value="3">Return Booked</mat-option>
                              <mat-option value="4">Return Cancelled</mat-option>
                              <mat-option value="5">Cab Reschedule</mat-option>
                              <mat-option value="6">Return Pending</mat-option>
                          </mat-select>
                      </div>
                      <div class="col-sm-4 mt-2">
                          <mat-form-field appearance="fill">
                              <mat-label>Enter a date range</mat-label>
                              <mat-date-range-input [rangePicker]="picker">
                                  <input matStartDate #dateRangeStart placeholder="Start date">
                                  <input matEndDate #dateRangeEnd placeholder="End date" (dateChange)="dateRangeChange(dateRangeStart, dateRangeEnd)">
                              </mat-date-range-input>
                              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                              <mat-date-range-picker #picker></mat-date-range-picker>
                          </mat-form-field>
                          <mat-icon (click)="clearDate()">clear</mat-icon>
                      </div>
                  </div>
              </mat-expansion-panel>
      </mat-accordion>
      <div class="card">
          <div class="container-fluid row">
              <div class="col-sm-6 p-3">
                  <button type="button" class="btn btn-success" [disabled]="loading" (click)="loadCabDetails(0,perpage)"><i class="fa fa-sync" [ngClass]="{'fa-spin':loading}"></i> Refresh List</button>
                  <button type="button" *ngIf="myrole=='1' || myrole=='8'" class="btn btn-success ml-2" [disabled]="loading" (click)="exportLeadData()"><i class="fa fa-file-excel"></i> Export List</button>
              </div>
              <div class="col-sm-6"><mat-paginator #paginatorTop [length]="length" [pageSizeOptions]="pageSizeOptions" [pageSize]="perpage" (page)="pageEvent = getServerData($event);paginatorBottom.pageIndex = $event.pageIndex"></mat-paginator></div>
          </div>
          <div class="tableFixHead" style="overflow: scroll">
          <table class="table table-striped">
              <thead>
                  <tr>
                      <th style="padding:0 10px;">#</th>
                      <th>Cab Status</th>
                      <th style="width: 250px;">Pickup Point</th>
                      <th style="width: 250px;">Drop off Location</th>
                      <th style="width: 250px;">Time Of Ride</th>
                      <th>Contact Number</th>
                      <th>IPD -ID</th>
                      <th>Requested By (BD Name)</th>
                      <th>Category</th>
                      <th>City</th>
                      <th>Rider Name</th>
                      <th>Doctor</th>

                      <th *ngIf="myrole=='1' || myrole=='8'">Action</th>
                  </tr>
              </thead>
              <tbody>
                <ng-container *ngFor="let cab of cabDetails;let index = index;">
                  <tr data-toggle="collapse" [attr.data-target]="'#collapse-' + index"
                  [attr.aria-expanded]="false" [attr.aria-controls]="'collapse-' + index">
                      <td >{{(pageIndex*perpage)+index+1}}</td>
                      <td>
                        <span class='p-2 badge' [ngClass]="{'badge-info':cab.cab_status==0}" *ngIf="cab.cab_status==0"><i class="fa fa-dot-circle"></i> Pending</span>
                        <span class='p-2 badge' [ngClass]="{'badge-info':cab.cab_status==1 && cab.return_cab==1}" *ngIf="cab.cab_status==1 && cab.return_cab==1 else booked"><i class="fa fa-check"></i> Return Pending</span>
                        <ng-template #booked>
                          <span class='p-2 badge' [ngClass]="{'badge-success':cab.cab_status==1}"><i class="fa fa-check"></i> Booked</span>
                        </ng-template>
                        <span class='p-2 badge' [ngClass]="{'badge-danger':cab.cab_status==2}" *ngIf="cab.cab_status==2"><i class="fa fa-times"></i> Cancelled</span>
                        <span class='p-2 badge' [ngClass]="{'badge-success':cab.cab_status==3}" *ngIf="cab.cab_status==3"><i class="fa fa-times"></i> Return Booked</span>
                        <span class='p-2 badge' [ngClass]="{'badge-danger':cab.cab_status==4}" *ngIf="cab.cab_status==4"><i class="fa fa-times"></i> Return Cancelled</span>
                        <span class='p-2 badge' [ngClass]="{'badge-info':cab.cab_status==5}" *ngIf="cab.cab_status==5"><i class="fa fa-dot-circle"></i> Cab Reschedule</span>
                      </td>
                      <td>{{cab.pickup_point}}</td>
                      <td>{{cab.hospital_name}} <br/> {{cab.hospital_address}}</td>
                      <td>{{cab.pickup_datetime*1000|date:'d MMM, yyyy'}} <br/> {{cab.pickup_datetime*1000|date:'hh:mm aa'}}</td>
                      <td>{{cab.phone}}</td>
                      <td>{{cab.patient_id}}</td>
                      <td>{{cab.bd_name}}</td>
                      <td>{{cab.category_name}}</td>
                      <td>{{cab.circle_name}}</td>
                      <td>{{cab.patient}}</td>
                      <td>{{cab.doctor_name}}</td>
                      <td *ngIf="myrole=='1' || myrole=='8'">
                           <div class="dropdown">
                              <button class="btn btn-secondary dropdown-toggle" type="button" id="{{cab.id}}" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                  Action
                              </button>
                              <div class="dropdown-menu" aria-labelledby="{{cab.id}}">
                                  <a class="dropdown-item" *ngIf="(myrole=='1' || myrole=='8') && (cab.cab_status == '2' || cab.cab_status == '0' || cab.cab_status == '5')" (click)="markStatus(cab.id,1)"><i class="fa fa-check"></i> Cab Book</a>
                                  <a class="dropdown-item" *ngIf="(myrole=='1' || myrole=='8') && (cab.cab_status == '1' || cab.cab_status == '0' || cab.cab_status == '5')" (click)="markStatus(cab.id,2)"><i class="fa fa-times"></i> Cab Cancel</a>
                                  <a class="dropdown-item" *ngIf="(myrole=='1' || myrole=='8') && (cab.return_cab == '1' && (cab.cab_status == '4' || cab.cab_status == '1'))" (click)="markStatus(cab.id,3)"><i class="fa fa-times"></i> Return Cab Book</a>
                                  <a class="dropdown-item" *ngIf="(myrole=='1' || myrole=='8') && (cab.return_cab == '1' && cab.cab_status == '3')" (click)="markStatus(cab.id,4)"><i class="fa fa-times"></i> Return Cab Cancel</a>
                              </div>
                          </div>
                      </td>
                  </tr>
                  <tr>
                    <td colspan="13" class="hiddenTr">
                      <div [attr.id]="'collapse-' + index" class="collapse" style="width: 90%;margin: auto;">
                        <table class="table table-striped">
                          <tbody>
                            <tr>
                              <th>Pickup Point</th>
                              <th>Drop off Location</th>
                              <th>Price</th>
                              <th style="width: 200px;">Time Of Ride</th>
                              <th>Cab Status</th>
                              <th>Created By</th>
                            </tr>
                          </tbody>
                          <tbody>
                            <tr *ngFor="let cabHistory of cab.cabHistories;let index1 = index;">
                              <td>
                                <span *ngIf="cabHistory.cab_type=='1'">{{cabHistory.pickup_point}}</span>
                                <span *ngIf="cabHistory.cab_type=='2'">{{cab.hospital_name}} <br/> {{cab.hospital_address}}</span>
                              </td>

                              <td>
                                <span *ngIf="cabHistory.cab_type=='2'">{{cabHistory.pickup_point}}</span>
                                <span *ngIf="cabHistory.cab_type=='1'">{{cab.hospital_name}} <br/> {{cab.hospital_address}}</span>
                              </td>
                              <td>
                                <span *ngIf="cabHistory.cab_status==1 || cabHistory.cab_status==3">{{cabHistory.price|currency:'INR'}}</span>
                                <span *ngIf="cabHistory.cab_status!=1 && cabHistory.cab_status!=3">-</span>
                                </td>
                              <td>
                                <span *ngIf="cabHistory.cab_status=='0' || cabHistory.cab_status=='1' || cabHistory.cab_status=='3' || cabHistory.cab_status=='5'">{{cabHistory.pickup_datetime*1000|date:'d MMM, yyyy'}} <br/> {{cabHistory.pickup_datetime*1000|date:'hh:mm aa'}}</span>
                                <span *ngIf="cabHistory.cab_status=='2' || cabHistory.cab_status=='4'">-</span>
                              </td>
                              <td>
                                <span class='p-2' *ngIf="cabHistory.cab_status==0">Pending</span>
                                <span class='p-2' *ngIf="cabHistory.cab_status==1">Booked</span>
                                <span class='p-2' *ngIf="cabHistory.cab_status==2">Cancelled</span>
                                <span class='p-2' *ngIf="cabHistory.cab_status==3">Return Booked</span>
                                <span class='p-2' *ngIf="cabHistory.cab_status==4">Return Cancelled</span>
                                <span class='p-2' *ngIf="cabHistory.cab_status==5">Cab Reschedule</span>
                              </td>
                              <td>{{cabHistory.created_by}} </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </td>
                  </tr>
                  <tr *ngIf="loading">
                      <td colspan="20" class="text-center"><i class="fa fa-spin fa-spinner fa-2x"></i></td>
                  </tr>
                  <tr *ngIf="loaded && !cabDetails.length">
                      <td colspan="20" ><i class="far fa-frown"></i> Cab deatils not found</td>
                  </tr>
                </ng-container>
              </tbody>
          </table>

          </div>
          <mat-paginator #paginatorBottom [length]="length" [pageSizeOptions]="pageSizeOptions" [pageSize]="perpage" (page)="pageEvent = getServerData($event);paginatorTop.pageIndex = $event.pageIndex"></mat-paginator>
      </div>
  </div>
</div>

